module.exports = __webpack_public_path__ + "src/assets/textures/env/barn/roof_trim_2K_bake.png";